export const SET_ROUND_DURATION = 'SET_ROUND_DURATION'
export const SET_SCORE_TO_WIN = 'SET_SCORE_TO_WIN'
export const SET_MINUS_SCORE = 'SET_MINUS_SCORE'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_LANDING = 'SET_LANDING'


